import { Inject, Injectable } from '@angular/core';
import { WINDOW } from '@adnoc/servicebox';

import { SandboxLocalStorageKeys } from '../enums';

import { SandboxLocalStorageService } from './local-storage.service';

@Injectable()
export class SandboxDarkModeService {
  private darkMode?: boolean;
  private rootElement?: HTMLElement;

  private readonly themeAttributeName = 'data-theme';
  private readonly darkModeThemeValue = 'dark';

  constructor(@Inject(WINDOW) window: Window, private sandboxLocalStorageService: SandboxLocalStorageService) {
    this.rootElement = window.document.documentElement;

    if (this.sandboxLocalStorageService.getItemValue(SandboxLocalStorageKeys.darkMode)) {
      this.enableDarkMode();
    }
  }

  get isDarkModeEnabled(): boolean {
    return this.darkMode ?? false;
  }

  toggleDarkMode(): void {
    if (this.isDarkModeEnabled) {
      this.disableDarkMode();
    } else {
      this.enableDarkMode();
    }

    this.sandboxLocalStorageService.setItemValue(SandboxLocalStorageKeys.darkMode, this.isDarkModeEnabled);
  }

  private enableDarkMode(): void {
    this.rootElement?.setAttribute(this.themeAttributeName, this.darkModeThemeValue);
    this.darkMode = true;
  }

  private disableDarkMode(): void {
    this.rootElement?.removeAttribute(this.themeAttributeName);
    this.darkMode = false;
  }
}
